import { httpClient } from '../httpClient';
export class HatenohamaRepository {
    // 通話明細取得（光コラボ）
    async getVoiceDetail(params) {
        const { data } = await httpClient.get(`hatenohama/voice-detail/fetch?useym=${params.useym}&pagenumber=${params.pageNumber}`);
        return data;
    }
    // 請求書
    async getBill() {
        const { data } = await httpClient.get(`hatenohama/bill/detail/fetch`);
        return data;
    }
    // データ通信量
    async getDataTraffic() {
        const { data } = await httpClient.get(`hatenohama/data-traffic/fetch`);
        return data;
    }
    // カード有効期限取得（ワーニング用）
    async getSlnKaiindataExpiration() {
        const { data } = await httpClient.post(`hatenohama/sln-kaiindata/expiration/fetch`);
        return data;
    }
    // 請求明細取得
    async getDetailAggregation(params) {
        const { data } = await httpClient.get(`hatenohama/detail-aggregation/fetch?billYm=${params.billYm}`);
        return data;
    }
}
